<template>
  <div>
    <div class="flex gap-2 text-primary">
      <v-icon
        color="primary"
        :size="20">
        mdi-truck-outline
      </v-icon>
      <span class="text-xl font-medium">{{ $t('shipping.header') }}</span>
    </div>
    <v-tabs
      v-model="tab"
      class="app-tab mt-6"
      show-arrows>
      <v-tab
        v-for="header in tabHeaders"
        :key="header.id"
        :href="`#${header.value}`">
        {{ header.title }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
        value="manage">
        <shipping-manage
          @input="refetchShippingCalculator()"
          @submit="refetchShippingCalculator()" />
      </v-tab-item>
      <v-tab-item
        v-if="permission.settingShippingCalculator"
        value="calculate">
        <v-card flat>
          <v-card-text>
            <calculate-data-table ref="CaculateDataTable" />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item
        v-if="permission.settingShippingCalculator"
        value="manage-cod">
        <v-card flat>
          <v-card-text>
            <cod-form />
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShippingManage from '@/views/Shipping/components/ShippingManage/ShippingManage.vue'
import CalculateDataTable from '@/views/Shipping/components/ShippingCalculate/CalculateDataTable.vue'
import CodForm from '@/views/Shipping/components/ShippingManageCod/CodForm.vue'

export default {
  name: 'Shipping',
  components: {
    ShippingManage,
    CalculateDataTable,
    CodForm
  },
  computed: {
    ...mapGetters({
      permission: 'Auth/permission'
    }),
    tabHeaders () {
      return [
        {
          id: '1',
          value: 'manage',
          title: 'จัดการขนส่ง',
          show: true
        },
        {
          id: '2',
          value: 'calculate',
          title: 'วิธีคิดราคาค่าจัดส่ง',
          show: this.permission.settingShippingCalculator
        },
        {
          id: '3',
          value: 'manage-cod',
          title: 'จัดการบัญชี EMS COD',
          show: true
        }
      ].filter((item) => item.show)
    },
    tab: {
      set (tab) {
        this.$router.push(`/shipping/${tab}`)
      },
      get () {
        return this.$route.path.split('/')[2]
      }
    }
  },
  methods: {
    refetchShippingCalculator () {
      if (this.permission.settingShippingCalculator) {
        this.$refs.CaculateDataTable.refetch()
      }
    }
  }
}
</script>

<style>
.v-window__container {
  background: #f1f2f5;
}
</style>
